import { ChatIcon, FilesIcon, VideoIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Flex } from "antd";
import { FatButton } from "components/FatButton/FatButton/";

export function ProjectSettingsFormExperience<T>(props: {
  value: T | undefined;
  onChange: (value: T) => void;
}) {
  const t = useTranslate();

  const items = [
    {
      icon: [<VideoIcon size={32} weight="duotone" key="video-icon" />],
      label: t("projects.components.ProjectSettingForm.videoOnly"),
      value: "video",
    },
    {
      icon: [
        <VideoIcon size={32} weight="duotone" key="video-icon" />,
        <FilesIcon size={32} weight="duotone" key="files-icon" />,
      ],
      label: t("projects.components.ProjectSettingForm.videoDoc"),
      value: "video_doc",
    },
    {
      icon: [
        <VideoIcon size={32} weight="duotone" key="video-icon" />,
        <FilesIcon size={32} weight="duotone" key="files-icon" />,
        <ChatIcon size={32} weight="duotone" key="chat-icon" />,
      ],
      label: t("projects.components.ProjectSettingForm.videoDocChat"),
      value: "video_doc_chat",
    },
  ];

  return (
    <Flex gap={50} justify="center" style={{ margin: 30 }}>
      {items.map((item, index) => (
        <>
          <FatButton
            title={item.label}
            key={index}
            icons={item.icon}
            style={{ width: 300, height: 350 }}
            onClick={() => props.onChange(item.value as T)}
            type={props.value === item.value ? "primary" : "default"}
            checked={props.value === item.value}
          />
        </>
      ))}
    </Flex>
  );
}
